export default {
	"38382": "randomized",
	"6835": "Participants",
	"56989": "Population",
	"6937": "Age",
	"41168": "Gender: Male",
	"41172": "Gender: Female",
	"17611641": "Gender: Unknown",
	"717774": "Race, American Indian/Alaska Native",
	"41183": "Race, Asian",
	"6835942": "Race, Native Hawaiian/Pacific Islander",
	"49491": "Race, Black/African American",
	"2145893": "Race, White/Caucasian",
	"1317833": "More than one race",
	"22508": "Ethnicity, Hispanic/Latino",
	"823183": "Ethnicity, Non-Hispanic/Latino",
	"7785": "Ethnicity, Other",
	"1317847": "Unknown/Not Reported",
	"18442": "Qualitative Note"
}